function flattenObject(obj) {
    let result = [];

    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            if (Array.isArray(obj[key])) {
                result = result.concat(obj[key]);
            } else if (typeof obj[key] === 'object' && obj[key] !== null) {
                result = result.concat(flattenObject(obj[key]));
            }
        }
    }

    return result;
}

export {
    flattenObject
}